import { render, staticRenderFns } from "./dxst.vue?vue&type=template&id=c0370f4a&"
import script from "./dxst.vue?vue&type=script&lang=ts&"
export * from "./dxst.vue?vue&type=script&lang=ts&"
import style0 from "./dxst.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports